import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {RxComponent} from 'app/core/components/common/rx.component';

import {ConfigService} from 'app/core/services/config.service';

import {ActionClickEvent, BulkActionClickEvent} from 'app/shared/components/dynamic-grid/dynamic-grid.component';
import {Subject} from 'rxjs/Rx';
import {NotificationService} from 'app/core/services/notification.service';
import {Observable} from 'rxjs/Observable';
import {SimpleInfoComponent} from 'app/shared/components/modal/simple-info.component';
import {SmartModalService} from 'app/core/services/smart-modal.service';
import {VenuesService} from '../venues.service';

@Component({
    selector: 'itpx-venues',
    templateUrl: './venues.component.html',
    styleUrls: ['./venues.component.css']
})
export class VenuesComponent extends RxComponent implements OnInit, OnDestroy {

    private url: string;
    private detailsRoute: string = '/organization/venues/{{key}}/details';
    private fields: any[];
    private bulkActionsConfig: any;
    private clearSelection = new Subject<any>();
    private gridRefresh = new Subject<any>();
    private gridClearSelection = new Subject<any>();
    private actionClicked = new Subject<ActionClickEvent>();
    private bulkActionClicked = new Subject<BulkActionClickEvent>();

    constructor(private configService: ConfigService,
                private notificationService: NotificationService,
                private service: VenuesService,
                private modalService: SmartModalService,
                private router: Router) {
        super();
        this.url = configService.get('server').url + configService.get('endpoints').solar.address.listroot.api;
        this.fields = this.service.getVenueGridFields();
        this.bulkActionsConfig = {
            key: 'id',
            actions: [
                { name: 'delete', label: 'Delete', icon: 'fa-times'}
            ],
            clearSelection : this.clearSelection
        };
    }

    ngOnInit() {
    }

    private onAddClicked(){
        this.router.navigate(['/organization/venues/add']);
    }

    private onEditActionClicked(e: ActionClickEvent) {
        let id = e.item['id'];
        console.log(id);
        this.router.navigate(['/organization/venues/edit/',id]);
    }

    private onDeleteActionClicked(e: BulkActionClickEvent) {
        this.openDeleteConfirmationModal('venues.messages.confirm-delete', 'Delete Venue')
            .subscribe(r => {
                if(r)
                    this.deleteVenues(e);
            })
    }

    private onActionSuccess(message: string, title: string) {
        this.notificationService.success(message, title);
        this.gridRefresh.next(true);
    }

    private openDeleteConfirmationModal(text: string, title: string): Observable<any> {
        let result = this.modalService.open(SimpleInfoComponent, {text: text, btn: 'btn-danger', btnYesText: 'Delete'}, title)
            .mapTo(true)
            .catch(_ => Observable.of(false));

        return result;
    }

    private deleteVenues(e: BulkActionClickEvent){
        this.service.deleteVenues(e.items)
            .bindToLifecycle(this)
            .subscribe(_ => {
                this.onActionSuccess('Selected venues deleted', 'Success');
                this.gridRefresh.next(true);
                this.clearSelection.next(true);
            });
    }

    ngOnDestroy() {
        this.modalService.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/venues/components/venues.component.ts